@use '@/scss/underscore' as _;

.switchLink {
  margin-top: _.unit(6);
}
